import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { landingPathFor } from "@/config/navigation";
import { useMe } from "@/features/auth/hooks";
import { useAuthStore } from "@/features/auth/store";

/**
 * Garde du tableau de bord : redirige l'utilisateur dont le rôle n'est pas
 * autorisé à le voir (réglage abonné « tableau de bord par rôle », résolu côté
 * back dans `active_display_config.hidden_nav`) vers sa page d'atterrissage.
 * Sans réglage, le tableau de bord reste visible par tous.
 */
export function DashboardGuard({ children }: { children: ReactNode }) {
  const meQuery = useMe();
  const storeMe = useAuthStore((s) => s.me);
  const me = meQuery.data ?? storeMe;

  if (meQuery.isLoading && !storeMe) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  const hidden = new Set(me?.active_display_config?.hidden_nav ?? []).has("/dashboard");
  if (hidden) {
    return <Navigate to={landingPathFor(me)} replace />;
  }
  return <>{children}</>;
}
